import React from 'react'

import { t } from 'src/translations'

import { ToggleInput } from 'shared/components/common/forms'

import { usePayment } from 'public/components/online_ordering/PaymentContext'

const SaveCardCheckbox = () => {
  const { newCreditCard, setSaveNewCreditCard } = usePayment()

  return (
    <>
      <ToggleInput
        type='checkbox'
        name='saveCreditCard'
        id='saveCreditCard'
        disabled={!newCreditCard}
        checked={newCreditCard?.saveCard || false}
        dataTestId='input-savecard'
        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
          setSaveNewCreditCard(event.target.checked)
        }
      >
        {t('save-card-checkbox.save-this-card')}
      </ToggleInput>
      <div className='note'>{t('save-card-checkbox.authorization-note')}</div>
    </>
  )
}

export default SaveCardCheckbox
